import * as React from 'react';
import { ButtonSecondary } from 'ui';
import styles from './sort-order-button.scss';

export interface SortOrderButtonProps {
  title?: string;
  onOpen: () => void;
  disabled?: boolean;
}

export const SortOrderButton = (props:SortOrderButtonProps) => (
  <div className={styles.sortOrderButton}>
      <ButtonSecondary onClick={props.onOpen} disabled={props.disabled}>
        {props.title}
      </ButtonSecondary>
    </div>
);
